var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 69,
    viewBox: "0 0 60 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02403 61.5156L0 0.115234L60 0.238621L54.6876 61.5156L30.2264 68.5985L5.02403 61.5156Z",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2266 62.6687V5.96289L54.9349 6.04515L50.5288 56.7795L30.2266 62.6687Z",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1399 20.128L48.8396 12.6328H10.8301L12.9301 35.6118H39.1622L38.1335 45.4126L29.7325 47.6772L21.2081 45.2065L20.7552 39.3589H13.2185L14.2481 51.3014L29.732 55.6252L45.3393 51.3014L47.4393 27.9933H19.8901L19.1077 20.128H48.1399Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 68.7128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.2e06d2fbef10567602e364c7a9ef585c.svg";
export { ForwardRef as ReactComponent };